import { createContext } from 'react';

import type { LensCalendar } from '~/types/leLens';

import { LENS_DEFAULT_CALENDAR } from './lensCalendar';

export const LensCalendarContext = createContext<LensCalendar>(LENS_DEFAULT_CALENDAR);
